import Vue from 'vue';

const success = ({ data }, resolve) => resolve(data);

const failed = (error, reject) => reject(error);

export default organizationNumber => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/clients/ehf_lookup?organization_number=${organizationNumber}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/ehfLookup.js